import { path } from 'ramda';

export const field = (name) => (data) => ({ [name]: data });

enum ServerStatusCode {
  PAYLOAD_LIMIT = 413,
}

const ERROR_MESSAGE = {
  [ServerStatusCode.PAYLOAD_LIMIT]:
    'Images upload failed. Please try with smaller image files',
};

const SERVER_ERROR_DATA = {
  [ServerStatusCode.PAYLOAD_LIMIT]: {
    error: { message: ERROR_MESSAGE[ServerStatusCode.PAYLOAD_LIMIT] },
    fields: [
      {
        message: ERROR_MESSAGE[ServerStatusCode.PAYLOAD_LIMIT],
        field: 'spots.0.placement_type',
      },
    ],
  },
};

const getDataFromResponse = path(['response', 'data']);
const getStatusFromResponse = path(['response', 'status']);

export const handleErrorResponseData = (err) => {
  const status = getStatusFromResponse(err) as ServerStatusCode;
  return SERVER_ERROR_DATA[status] || getDataFromResponse(err);
};
